if(!window.logger) window.Logger = function(options){
  var mode = "production"
  var self = this
  if(options && options.env)
    mode = options.env

  this.warn = function(){
    if(mode == "development"){
      if(window.console && window.console.log){
        console.log(arguments)
      }

      return
    }

    if(LE){

      if(arguments.length == 0){
        return
      }

      var entry = {
        environment: mode,
        data: _.toArray(arguments)
      }

      if(entry.data.length == 0 || !entry.data[0] || !entry.data[0].length === undefined) return

      // var userString = localStorage.getItem("WSSE")
      var userEmail = window.user ? window.user.get("email") : "NO USER"

      var account_type = ""

      if(window.permissions && window.permissions.hasRole("self_serve") && !window.permissions.hasRole("is_adparlor")){
        account_type = "self_serve"
      }else if(window.permissions && window.permissions.hasRole("managed") && !window.permissions.hasRole("is_adparlor")){
        account_type = "managed"
      }

      var user_age
      if(window.user && window.user.get("created_at")){
        user_age = moment().diff(moment(window.user.get("created_at")), "days")
      }

      entry["username"] = userEmail
      if(account_type) entry["account_type"] = account_type
      if(user_age) entry["user_age"] = user_age

      setTimeout(function(){
        LE.warn(entry)
      }, 100)

    }
  }

  this.log = function(){
    if(mode == "development"){
      if(window.console && window.console.log){
        console.log(arguments)
      }

      return
    }

    if(LE){

      if(arguments.length == 0){
        return
      }

      var data = _.toArray(arguments)

      if(arguments.length == 1){
        data = arguments[0]
      }

      var entry = {
        environment: mode,
        data: data
      }

      if(entry.data.length == 0) return

      // var userString = localStorage.getItem("WSSE")
      var userEmail = window.user ? window.user.get("email") : "NO USER"

      account_type = ""

      if(window.permissions && window.permissions.hasRole("self_serve") && !window.permissions.hasRole("is_adparlor")){
        account_type = "self_serve"
      }else if(window.permissions && window.permissions.hasRole("managed") && !window.permissions.hasRole("is_adparlor")){
        account_type = "managed"
      }

      entry = _.merge(entry, {
        username: userEmail,
        account_type: account_type
      })

      setTimeout(function(){
        LE.log(entry)
      }, 100)

    }
  }
}

